import * as qs      from 'query-string';

interface ParsedQueryString {
    [key: string]: string;
}

export const cacheBuster = () => Math.floor((Math.random() * 10000));

/**
 * @method generateQueryString
 * @description Transform an object of parameters/values into a valid query string
 * @param params {object}
 * @return {string}
 */
export const generateQueryString = (params: object): string => {
    return qs.stringify(params);
};

/**
 * @method generateCacheBusterQueryString
 * @description Transform an object of parameters/values into a valid query string with an added cacheBuster property
 * @param params {object}
 * @return {string}
 */
export const generateCacheBusterQueryString = (params: object): string => {
    return qs.stringify({ ...params, cacheBuster: cacheBuster()});
};

/**
 * @method parseQueryString
 * @description Parses query string and returns an object of parameters and values
 * @param location {Location}
 * @return {ParsedQueryString}
 */
export const parseQueryString = (queryString: string): ParsedQueryString => {
    return qs.parse(queryString);
};

/**
 * @method getQueryString
 * @description Returns the query string as an object of parameters and values
 * @return {ParsedQueryString}
 */
export const getQueryString = (): ParsedQueryString => {
    return parseQueryString(location.search);
};

/**
 * @method getQueryStringValueByKey
 * @description Returns the value of a particular query stirng param, if it exists
 * @return {string}
 */
export const getQueryStringValueByKey = (key: string): string => {
    return getQueryString()[key] || null;
};



// WEBPACK FOOTER //
// ./src/helpers/queryStringUtils.ts